export const clearAuthSession = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("id");
    sessionStorage.removeItem("user_role");
    sessionStorage.removeItem("org_code");
    sessionStorage.removeItem("identifier");
};

const decodeJwtPayload = (token) => {
    try {
        const payload = token.split(".")[1];
        if (!payload) return null;

        const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");

        return JSON.parse(atob(padded));
    } catch {
        return null;
    }
};

//just checks expiry date of token. signature validation done on backend
export const isTokenExpired = (token) => {
    const payload = decodeJwtPayload(token);

    if (!payload?.exp) return true;

    const now = Math.floor(Date.now() / 1000);
    return payload.exp <= now;
};

export const hasRole = (...roles) => {
    return roles.includes(sessionStorage.getItem("user_role"));
};

export const isViewer = () => hasRole("SUPER_ADMIN", "ADMIN", "VIEWER");
export const isAdmin = () => hasRole("SUPER_ADMIN", "ADMIN");